<section class="head">
  <div class="back" id="back">

    <div class="inner">
      <div class="fass" id="fass"></div>
      <div class="splashes"></div>
      <div class="zapfhahn" id="zapfhahn"></div>
      <div class="nebel"></div>
      <div class="nebel2"></div>
      <div class="board" id="board"></div>
    </div>
  </div>
  <div class="logo" id="logo">
    <img src="assets/images/DRC-Logo-white.svg" alt="Dart Rock Cafe Lohfelden">
    <div>Hauptstrasse 46, 34253 Lohfelden</div>
  </div>

</section>
